import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, vShow as _vShow, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "md:flex md:items-center md:justify-end bg-white border-b border-gray-200 flex py-4 px-8" }
const _hoisted_2 = { class: "max-w-lg w-full md:w-80 lg:max-w-md" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", {
  for: "search",
  class: "sr-only"
}, "Search", -1)
const _hoisted_4 = { class: "relative text-gray-400 focus-within:text-gray-600" }
const _hoisted_5 = { class: "pointer-events-none absolute inset-y-0 pl-3 left-0 flex items-center" }
const _hoisted_6 = ["placeholder"]
const _hoisted_7 = { class: "flex flex-col md:flex-row mx-auto md:mr-auto md:mx-0" }
const _hoisted_8 = { class: "px-8 py-6" }
const _hoisted_9 = { class: "space-y-8 divide-y divide-gray-200 bg-white px-10 py-9 rounded-md shadow-md text-center" }
const _hoisted_10 = { class: "py-6" }
const _hoisted_11 = { class: "sm:mx-6 md:mx-8 bg-white shadow overflow-x-auto sm:rounded-md" }
const _hoisted_12 = { class: "shadow overflow-x-auto border-b border-gray-200 sm:rounded-lg" }
const _hoisted_13 = { class: "flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", {
  class: "hidden sm:inline-block sm:align-middle sm:h-screen",
  "aria-hidden": "true"
}, "​", -1)
const _hoisted_15 = { class: "inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-md sm:w-full sm:p-6" }
const _hoisted_16 = { class: "mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100" }
const _hoisted_17 = { class: "mt-2 text-center sm:mt-5" }
const _hoisted_18 = { class: "pt-5 text-left" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_25 = { class: "mt-2 pb-2 text-left" }
const _hoisted_26 = { class: "text-sm" }
const _hoisted_27 = { class: "mt-1" }
const _hoisted_28 = {
  key: 0,
  class: "flex flex-col justify-center mb-2 mt-4"
}
const _hoisted_29 = {
  key: 0,
  class: "text-red-600"
}
const _hoisted_30 = ["placeholder"]
const _hoisted_31 = { class: "mt-5 sm:mt-6 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense" }
const _hoisted_32 = { class: "flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("span", {
  class: "hidden sm:inline-block sm:align-middle sm:h-screen",
  "aria-hidden": "true"
}, "​", -1)
const _hoisted_34 = { class: "inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-md sm:w-full sm:p-6" }
const _hoisted_35 = { class: "mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100" }
const _hoisted_36 = { class: "mt-2 text-center sm:mt-5" }
const _hoisted_37 = { class: "pt-5 text-left" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_43 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_44 = { class: "mt-5 sm:mt-6 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense" }

import "dayjs/locale/th";
import dayjs from "dayjs";
import stringify from "qs-stringify";
import localizedFormat from "dayjs/plugin/localizedFormat";
import { AxiosInstance } from "axios";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";
import { inject, onMounted, ref, watch } from "vue";
import Navbar from "@/components/tools/Navbar.vue";
import DataTable from "@/components/tools/DataTable.vue";
import Pagination from "@/components/tools/Pagination.vue";
import { formatNumber, translate } from "@/utils/tools";

import Toast from "@/components/tools/Toast.vue";
import { DepositPagination } from "./types/deposit.type";
import DateSelector from "@/components/tools/DateTimeSelector.vue";
import {
  Dialog,
  DialogOverlay,
  DialogTitle,
  TransitionChild,
  TransitionRoot
} from "@headlessui/vue";
import ApproveTopupPaymentSwitchingFilterDialog
  from "@/components/dialogs/ApproveTopupPaymentSwitchingFilterDialog.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ApproveTopupUser',
  setup(__props) {

const router = useRouter();

dayjs.extend(localizedFormat);
const SearchIcon = require("@heroicons/vue/solid/SearchIcon");
const axios = inject("$axios") as AxiosInstance;
const store = useStore();
const route = useRoute();
const dataRows = ref<DepositPagination[]>([]);
const isLoaded = ref(false);
const approveDialogShow = ref(false)
const rejectDialogShow = ref(false)
const processedApproval = ref(false)
const toastConfig = ref({
  show: false,
  message: "",
  success: false,
  warning: false
});
const pageConfig = ref({
  page: 1,
  count: 0,
  pageCount: 0,
  rowsPerPage: 10,
  dataLength: 0,
  search: undefined,
  sort: [["requested_at", "DESC"]],
});
const filterForm = ref({
  bankAccountNumber: null,
  approve_by: null,
  from: null,
  channel: null,
  to: null,
});
const advanceFilterModal = ref(false);
const approveFromCm = ref({
  id: '',
  userPhone: '',
  transactionDate: '',
  bankName: '',
  bankAccountNumber: '',
  bankAccountOwnerNumber: '',
  amount: '',
  remark: '',
})
const rejectFromCm = ref({
  id: '',
  userPhone: '',
  transactionDate: '',
  bankName: '',
  bankAccountNumber: '',
  bankAccountOwnerNumber: '',
  amount: '',
  remark: '',
})
// const approveDialogShow = ref(false)
const isCheckTOTP = ref(false);
const isEnabledCmsOtp = ref(false)
const currentAttempts = ref(0);
const totp = ref("");
const isWorking = ref(false);
const isNotified = ref(store.state.user.topupNotification);

const columns = ref([
  {
    label: translate("messages.approveTopupV2.transactionDate"),
    field: "transactionDate",
    format: (data: any) => dayjs(data.transactionDate).locale("th").format("LLL"),
  },
  {
    label: translate("messages.approveTopupV2.bankAccount"),
    field: "bankAccount",
    align: "center",
    sort: false,
    isSorted: false,
    format: (data: any) => data.bankAccount ? data.bankAccount : "-",
  },
  {
    label: translate("messages.approveTopupV2.paymentName"),
    field: "paymentName",
    align: "center",
    sort: false,
    isSorted: false,
    format: (data: any) => (data.paymentName ? data.paymentName : "-"),
  },
  {
    label: translate("messages.approveTopupV2.refCode1"),
    field: "refCode",
    align: "center",
    sort: false,
    isSorted: false,
    format: (data: any) => data.refcode ? data.refcode : "-",
  },
  {
    label: translate("messages.approveTopupV2.amount"),
    field: "amount",
    align: "center",
    sort: false,
    isSorted: false,
    format: (data: any) => (data.amount ? formatNumber(data.amount) : "-"),
  },
  {
    label: translate("messages.approveTopupV2.status"),
    field: "status",
    align: "center",
    sort: false,
    isSorted: false,
    format: (data: any) => {
      return data.status ? data.status : "-"
    },
    class: (data: any) => {
      let css = 'text-white font-bold text-xs rounded py-1'
      switch (data.status) {
        case 'WAITING_APPROVE':
          css += ' bg-yellow-500'
          break;
        case 'OPEN':
          css += ' bg-blue-500'
          break;
        case 'CALLBACK_SUCCEED':
          css += ' bg-blue-400'
          break;
        case 'SUBMITTED':
          css += ' bg-blue-500'
          break;
        case 'COMPLETED':
          css += ' bg-green-500'
          break;
        case 'REJECTED':
          css += ' bg-red-400'
          break;
        case 'CALLBACK_FAILED':
          css += ' bg-red-300'
          break;
        case 'APPROVING':
          css += ' bg-yellow-300'
          break;
        default:
          css += ' bg-red-500'
          break;
      }
      return css
    },
  },
  {
    label: translate("messages.approveTopupV2.createdAt"),
    field: "createdAt",
    align: "center",
    sort: false,
    isSorted: false,
    format: (data: any) => dayjs(data.createdAt).locale("th").format("LLL"),
  },
  {
    label: translate("messages.approveTopupV2.approve"),
    field: "status",
    align: "center",
    sort: false,
    isSorted: false,
    isFunction: true,
    function: async (data: any) => {
      if (data.status === 'WAITING_APPROVE') {
        approveFromCm.value = {
          id: data.id,
          userPhone: ``,
          transactionDate: data.transactionDate,
          bankName: data.bank,
          bankAccountNumber: data.bankAccount,
          bankAccountOwnerNumber: data.bankOwnerAccount,
          amount: formatNumber(data.amount),
          remark: data.remark
        }
        approveDialogShow.value = true
      }
      return
    },
    class: (data: any) => {
      if (data.status === 'WAITING_APPROVE') return 'content-center bg-blue-500 hover:bg-blue-700 text-white font-bold rounded-full'
      return 'block'
    },
    format: (data: any) => {
      if (data.status === 'WAITING_APPROVE') return translate("messages.approveTopupV2.approve")
      return ''
    },
    permission: 'PAYMENT_CONFIG.DEPOSIT.APPROVE'
  },
  {
    label: translate("messages.approveTopupV2.reject"),
    field: "status",
    align: "center",
    sort: false,
    isSorted: false,
    isFunction: true,
    function: async (data: any) => {
      if (data.status === 'WAITING_APPROVE') {
        rejectFromCm.value = {
          id: data.id,
          userPhone: ``,
          transactionDate: data.transactionDate,
          bankName: data.bank,
          bankAccountNumber: data.bankAccount,
          bankAccountOwnerNumber: data.bankOwnerAccount,
          amount: formatNumber(data.amount),
          remark: data.remark
        }
        rejectDialogShow.value = true
      }
      return
    },
    class: (data: any) => {
      if (data.status === 'WAITING_APPROVE') return 'content-center bg-red-500 hover:bg-red-700 text-white font-bold rounded-full'
      return 'block'
    },
    format: (data: any) => {
      if (data.status === 'WAITING_APPROVE') return translate("messages.approveTopupV2.reject")
      return ''
    },
    permission: 'PAYMENT_CONFIG.DEPOSIT.APPROVE'
  },
]);


const filterModal = (data = { flag: 0, chanel: null }) => {
  advanceFilterModal.value = !advanceFilterModal.value;
  if (data.flag == 1) {
    pageConfig.value.page = 1;
    filterForm.value.channel = data.chanel;
    fetchPageData();
  }
};

const onReject = async () => {
  if(processedApproval.value){
    return
  }
  processedApproval.value = true
  try {
    const url = `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/be-payment/bank-deposit-pending/reject/operator`;
    const payload = {
      id: rejectFromCm.value.id,
    }
    const data = await axios
        .post(url, payload)
        .then(({ data }) => data);
    if (!data) return alert("fail approve")
    alert('success')
    rejectDialogShow.value = false
    await fetchPageData()
  } catch (e) {
    alert('Failed')
  }
  processedApproval.value = false
}
const onApprove = async () => {
  if(processedApproval.value){
    return
  }
  processedApproval.value = true
  try {
    const url = `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/be-payment/bank-deposit-pending/approve/user`;
    const payload = {
      userPhone: approveFromCm.value.userPhone,
      id: approveFromCm.value.id,
      operatorId: store.state.selectedOperator.operatorId,
      adminId: store.state.user.id
    }
    const data = await axios
        .post(url, payload)
        .then(({ data }) => data)
        .catch((e) => e);
    if (data?.response?.status === 500) {
      approveDialogShow.value = false
      return alert(data?.response?.data?.message || 'fail approve')
    }
    alert('success')
    approveDialogShow.value = false
    isCheckTOTP.value = false
    totp.value = ''
    await fetchPageData()
  } catch (e) {
    console.log(e)
    alert('Failed')
  }
  processedApproval.value = false
}

const onSearch = (payload: { from: null; to: null }) => {
  filterForm.value.from = payload.from;
  filterForm.value.to = payload.to;
  fetchPageData();
};


const fetchPageData = async () => {
  const { page, rowsPerPage} = pageConfig.value;
  const { approve_by, from, to, channel, bankAccountNumber } = filterForm.value;

  const payload: any = {
    page: page,
    pageSize: rowsPerPage,
    operatorId: store.state.selectedOperator.operatorId,
    bankAccountNumber: bankAccountNumber ? bankAccountNumber : undefined,
    status: ["WAITING_APPROVE", "OPEN"],
    approve_by: approve_by || undefined,
    channel: channel || undefined,
    startDate: dayjs(from) || null,
    endDate: dayjs(to) || null,
    sort: [['transactionDate','DESC']],
  };
  if (!from) delete payload.startDate;
  if (!to) delete payload.endDate;

  const url = `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/be-payment/bank-deposit-pending/pagination`;
  const { result: data } = await axios
      .post(url, payload)
      .then(({ data }) => data);

  pageConfig.value.dataLength = data.length;

  if (data.length > 0) dataRows.value = data;
  else dataRows.value = [];
  pageConfig.value = {
    ...pageConfig.value,
    // count,
    // pageCount: Math.ceil(count / rowsPerPage),
  };
  /** update url to persist page config */
  window.history.replaceState(
      {},
      document.title,
      `?${stringify({ page, rowsPerPage })}`
  );
  isEnabledCmsOtp.value = store.state.selectedOperator.bypassPaymentApprovalTotp
  totp.value = ''
  isLoaded.value = true;
};


const onCheckTOTP = async () => {
  try {
    const checkTotp = await axios.post(
        `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/auth/admin-totp-check`,
        {
          requestId: Date.now().toString(),
          requestTs: Date.now(),
          code: totp.value,
          userId: store.state.user.id,
          callerFunction: "Confirm Approve Payout",
        },
        { headers: { "x-cm-forwarded-for": store.state.user.ip } }
    );
    if(checkTotp.data.result.status !== 'success'){
      throw new Error(`Totp failed`);
    }
    onApprove();
  } catch (e: any) {
    if (e?.response?.data?.isBlackList) {
      store.commit("removeUserInfo");
      store.commit("removeOperators");
      router.push({ name: "Login" });
      window.location.reload();
    } else if (e?.response?.data?.attempts) {
      currentAttempts.value = e.response.data.attempts;
    }
    alert("รหัส Google Authenticator ไม่ถูกต้อง");
  }
};


// const updateNotification = () => {
//   const notification = isNotified.value ? false : true;
//   isNotified.value = notification;
//   store.commit("serUserTopupNotification", notification);
// };

onMounted(() => {
  pageConfig.value.page = Number(route.query.page) || 1;
  pageConfig.value.rowsPerPage = Number(route.query.rowsPerPage) || 10;
  fetchPageData();
});

/** fetch data when current page was changed */
watch(
    () => pageConfig.value.page,
    () => fetchPageData()
);


/** fetch data when rows per page was changed */
watch(
    () => pageConfig.value.rowsPerPage,
    () => {
      pageConfig.value.page = 1;
      fetchPageData();
    }
)

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Navbar, {
      title: _ctx.$t('messages.approveTopupV2.assignUserTopup')
    }, null, 8, ["title"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_unref(SearchIcon), {
              class: "h-5 w-5",
              "aria-hidden": "true"
            })
          ]),
          _withDirectives(_createElementVNode("input", {
            id: "search",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filterForm.value.bankAccountNumber) = $event)),
            class: "block w-full bg-white py-2 pl-10 focus:bg-white pr-3 border border-transparent rounded-md leading-5 text-gray-900 placeholder-gray-500 focus:ring-offset-blue-600 focus:ring-white focus:border-white sm:text-sm",
            placeholder: _ctx.$t('messages.depositPaymentSwitching.searchBankAccountNumber'),
            onInput: _cache[1] || (_cache[1] = ($event: any) => (fetchPageData())),
            type: "search",
            name: "search"
          }, null, 40, _hoisted_6), [
            [_vModelText, filterForm.value.bankAccountNumber]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(DateSelector, { onSearch: onSearch })
      ])
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_font_awesome_icon, {
          class: "text-gray-500",
          icon: ['fas', 'circle-notch'],
          transform: "grow-6",
          spin: ""
        })
      ])
    ], 512), [
      [_vShow, !isLoaded.value]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createVNode(DataTable, {
            columns: columns.value,
            data: dataRows.value,
            onSort: _ctx.doSort
          }, null, 8, ["columns", "data", "onSort"]),
          _createVNode(Pagination, {
            config: pageConfig.value,
            "onUpdate:config": _cache[2] || (_cache[2] = ($event: any) => ((pageConfig).value = $event))
          }, null, 8, ["config"])
        ])
      ])
    ], 512), [
      [_vShow, isLoaded.value]
    ]),
    _createVNode(Toast, {
      show: toastConfig.value.show,
      "onUpdate:show": _cache[3] || (_cache[3] = ($event: any) => ((toastConfig.value.show) = $event)),
      message: toastConfig.value.message,
      success: toastConfig.value.success
    }, null, 8, ["show", "message", "success"]),
    _createVNode(ApproveTopupPaymentSwitchingFilterDialog, {
      class: "z-10",
      show: advanceFilterModal.value,
      "onUpdate:show": _cache[4] || (_cache[4] = ($event: any) => ((advanceFilterModal).value = $event)),
      form: filterForm.value,
      "onUpdate:form": _cache[5] || (_cache[5] = ($event: any) => ((filterForm).value = $event)),
      onSubmit: filterModal
    }, null, 8, ["show", "form"]),
    _createVNode(_unref(TransitionRoot), {
      as: "template",
      show: approveDialogShow.value
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Dialog), {
          as: "div",
          static: "",
          class: "fixed z-10 inset-0 overflow-y-auto"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_unref(TransitionChild), {
                as: "template",
                enter: "ease-out duration-300",
                "enter-from": "opacity-0",
                "enter-to": "opacity-100",
                leave: "ease-in duration-200",
                "leave-from": "opacity-100",
                "leave-to": "opacity-0"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(DialogOverlay), { class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" })
                ]),
                _: 1
              }),
              _hoisted_14,
              _createVNode(_unref(TransitionChild), {
                as: "template",
                enter: "ease-out duration-300",
                "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                "enter-to": "opacity-100 translate-y-0 sm:scale-100",
                leave: "ease-in duration-200",
                "leave-from": "opacity-100 translate-y-0 sm:scale-100",
                "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_16, [
                        _createVNode(_component_font_awesome_icon, {
                          class: "text-green-600",
                          icon: ['far', 'check'],
                          transform: "grow-2"
                        })
                      ]),
                      _createElementVNode("div", _hoisted_17, [
                        _createVNode(_unref(DialogTitle), {
                          as: "h3",
                          class: "text-lg leading-6 font-medium text-gray-900"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("messages.approveTopupV2.approveTopupTitle")), 1)
                          ]),
                          _: 1
                        }),
                        _createElementVNode("div", _hoisted_18, [
                          _createElementVNode("b", null, _toDisplayString(_ctx.$t("messages.approvePayoutV2.bankAccountName")), 1),
                          _createTextVNode(": " + _toDisplayString(approveFromCm.value.bankName || "-"), 1),
                          _hoisted_19,
                          _createElementVNode("b", null, _toDisplayString(_ctx.$t("messages.approveTopupV2.bankAccountNumber")), 1),
                          _createTextVNode(": " + _toDisplayString(approveFromCm.value.bankAccountNumber ||
                "-"), 1),
                          _hoisted_20,
                          _createElementVNode("b", null, _toDisplayString(_ctx.$t("messages.approveTopupV2.bankAccountOwnerNumber")), 1),
                          _createTextVNode(": " + _toDisplayString(approveFromCm.value.bankAccountOwnerNumber ||
                "-"), 1),
                          _hoisted_21,
                          _createElementVNode("b", null, _toDisplayString(_ctx.$t("messages.approveTopupV2.remark")), 1),
                          _createTextVNode(": " + _toDisplayString(approveFromCm.value.remark ||
                "-"), 1),
                          _hoisted_22,
                          _createElementVNode("b", null, _toDisplayString(_ctx.$t("messages.approveTopupV2.amount")), 1),
                          _createTextVNode(": " + _toDisplayString(approveFromCm.value.amount || "-"), 1),
                          _hoisted_23,
                          _createElementVNode("b", null, _toDisplayString(_ctx.$t("messages.approveTopupV2.transactionDate")), 1),
                          _createTextVNode(": " + _toDisplayString(_unref(dayjs)(approveFromCm.value.transactionDate).locale("th").format("LLL") || "-"), 1),
                          _hoisted_24
                        ]),
                        _createElementVNode("div", _hoisted_25, [
                          _createElementVNode("label", _hoisted_26, _toDisplayString(_ctx.$t("messages.approveTopupV2.userCode")), 1),
                          _createElementVNode("div", _hoisted_27, [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((approveFromCm.value.userPhone) = $event)),
                              name: "userCode",
                              id: "userCode",
                              class: "shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border-gray-300 rounded-md"
                            }, null, 512), [
                              [_vModelText, approveFromCm.value.userPhone]
                            ])
                          ])
                        ])
                      ])
                    ]),
                    (isCheckTOTP.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                          _createElementVNode("span", null, _toDisplayString(_ctx.$t("messages.logIn.inputTotp")), 1),
                          (currentAttempts.value > 0)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_29, " ใส่ผิดไปแล้ว " + _toDisplayString(currentAttempts.value) + " ครั้ง ", 1))
                            : _createCommentVNode("", true),
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((totp).value = $event)),
                            class: "rounded",
                            maxlength: "6",
                            placeholder: _ctx.$t('messages.logIn.totpCode')
                          }, null, 8, _hoisted_30), [
                            [_vModelText, totp.value]
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_31, [
                      (isCheckTOTP.value)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: "w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-blue-600 text-base font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:col-start-2 sm:text-sm",
                            onClick: _cache[8] || (_cache[8] = ($event: any) => (onCheckTOTP('CM')))
                          }, " Approve "))
                        : _createCommentVNode("", true),
                      (!isCheckTOTP.value)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            type: "button",
                            onClick: _cache[9] || (_cache[9] = ($event: any) => (isEnabledCmsOtp.value ? isCheckTOTP.value = true : onApprove())),
                            class: "w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-blue-600 text-base font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:col-start-2 sm:text-sm"
                          }, _toDisplayString(_ctx.$t("messages.approveTopupV2.confirmTopup")), 1))
                        : _createCommentVNode("", true),
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[10] || (_cache[10] = () => { approveDialogShow.value = false }),
                        class: "mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:mt-0 sm:col-start-1 sm:text-sm",
                        ref: "cancelButtonRef"
                      }, " Cancel ", 512)
                    ])
                  ])
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_unref(TransitionRoot), {
      as: "template",
      show: rejectDialogShow.value
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Dialog), {
          as: "div",
          static: "",
          class: "fixed z-10 inset-0 overflow-y-auto"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_32, [
              _createVNode(_unref(TransitionChild), {
                as: "template",
                enter: "ease-out duration-300",
                "enter-from": "opacity-0",
                "enter-to": "opacity-100",
                leave: "ease-in duration-200",
                "leave-from": "opacity-100",
                "leave-to": "opacity-0"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(DialogOverlay), { class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" })
                ]),
                _: 1
              }),
              _hoisted_33,
              _createVNode(_unref(TransitionChild), {
                as: "template",
                enter: "ease-out duration-300",
                "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                "enter-to": "opacity-100 translate-y-0 sm:scale-100",
                leave: "ease-in duration-200",
                "leave-from": "opacity-100 translate-y-0 sm:scale-100",
                "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_34, [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_35, [
                        _createVNode(_component_font_awesome_icon, {
                          class: "text-green-600",
                          icon: ['far', 'check'],
                          transform: "grow-2"
                        })
                      ]),
                      _createElementVNode("div", _hoisted_36, [
                        _createVNode(_unref(DialogTitle), {
                          as: "h3",
                          class: "text-lg leading-6 font-medium text-gray-900"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("messages.approveTopupV2.rejectTopupTitle")), 1)
                          ]),
                          _: 1
                        }),
                        _createElementVNode("div", _hoisted_37, [
                          _createElementVNode("b", null, _toDisplayString(_ctx.$t("messages.approvePayoutV2.bankAccountName")), 1),
                          _createTextVNode(": " + _toDisplayString(rejectFromCm.value.bankName || "-"), 1),
                          _hoisted_38,
                          _createElementVNode("b", null, _toDisplayString(_ctx.$t("messages.approveTopupV2.bankAccountNumber")), 1),
                          _createTextVNode(": " + _toDisplayString(rejectFromCm.value.bankAccountNumber ||
                "-"), 1),
                          _hoisted_39,
                          _createElementVNode("b", null, _toDisplayString(_ctx.$t("messages.approveTopupV2.bankAccountOwnerNumber")), 1),
                          _createTextVNode(": " + _toDisplayString(rejectFromCm.value.bankAccountOwnerNumber ||
                "-"), 1),
                          _hoisted_40,
                          _createElementVNode("b", null, _toDisplayString(_ctx.$t("messages.approveTopupV2.remark")), 1),
                          _createTextVNode(": " + _toDisplayString(rejectFromCm.value.remark ||
                "-"), 1),
                          _hoisted_41,
                          _createElementVNode("b", null, _toDisplayString(_ctx.$t("messages.approveTopupV2.amount")), 1),
                          _createTextVNode(": " + _toDisplayString(rejectFromCm.value.amount || "-"), 1),
                          _hoisted_42,
                          _createElementVNode("b", null, _toDisplayString(_ctx.$t("messages.approveTopupV2.transactionDate")), 1),
                          _createTextVNode(": " + _toDisplayString(_unref(dayjs)(rejectFromCm.value.transactionDate).locale("th").format("LLL") || "-"), 1),
                          _hoisted_43
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_44, [
                      _createElementVNode("button", {
                        class: "w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-red-600 text-base font-medium text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:col-start-2 sm:text-sm",
                        onClick: _cache[11] || (_cache[11] = ($event: any) => (onReject()))
                      }, " Reject "),
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[12] || (_cache[12] = () => { rejectDialogShow.value = false }),
                        class: "mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:mt-0 sm:col-start-1 sm:text-sm",
                        ref: "cancelButtonRef"
                      }, " Cancel ", 512)
                    ])
                  ])
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["show"])
  ], 64))
}
}

})